export default "__VITE_ASSET__BOr9VApv__"